export default __webpack_public_path__ + "static/media/invite-students.2e0669e6.png";